/* eslint-disable @trello/assets-alongside-implementation */
import type { FunctionComponent } from 'react';

import type { ActionSubjectIdType, SourceType } from '@trello/analytics-types';
import { Analytics } from '@trello/atlassian-analytics';
import { forNamespace } from '@trello/legacy-i18n';

import styles from './SocialShareLinks.less';

import emailIconSvg from 'resources/images/social-icons/email-icon.svg';
import facebookIconSvg from 'resources/images/social-icons/facebook-icon.svg';
import linkedinIconSvg from 'resources/images/social-icons/linkedin-icon.svg';
import twitterIconSvg from 'resources/images/social-icons/twitter-icon.svg';
const format = forNamespace('social share links');

export const SocialShareLinks: FunctionComponent<{
  tweet: string;
  emailBody: string;
  url: string;
  analyticsSource: SourceType;
  hashtags?: string[];
  boardId?: string;
}> = ({ tweet, emailBody, url, analyticsSource, hashtags, boardId = '' }) => {
  const sendAnalyticsUIEvent = (analyticsSubject: ActionSubjectIdType) => {
    Analytics.sendClickedButtonEvent({
      buttonName: analyticsSubject,
      source: analyticsSource,
      containers: { board: { id: boardId } },
    });
  };

  return (
    <ul className={styles.socialShareLinksList}>
      <li>
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
            url,
          )}&text=${encodeURIComponent(tweet)}${
            hashtags && `&hashtags=` + hashtags.join(',')
          }`}
          target="_blank"
          rel="noopener noreferrer"
          title={format('share on', { platform: 'Twitter' })}
          onClick={() => sendAnalyticsUIEvent('twitterButton')}
        >
          <img
            src={twitterIconSvg}
            alt={format('share on', { platform: 'Twitter' })}
          />
        </a>
      </li>
      <li>
        <a
          href={`https://www.facebook.com/sharer.php?u=${url}&display=page`}
          target="_blank"
          rel="noopener noreferrer"
          title={format('share on', { platform: 'Facebook' })}
          onClick={() => sendAnalyticsUIEvent('facebookButton')}
        >
          <img
            src={facebookIconSvg}
            alt={format('share on', { platform: 'Facebook' })}
          />
        </a>
      </li>
      <li>
        <a
          href={`https://www.linkedin.com/shareArticle?&url=${url}`}
          target="_blank"
          rel="noopener noreferrer"
          title={format('share on', { platform: 'LinkedIn' })}
          onClick={() => sendAnalyticsUIEvent('linkedinButton')}
        >
          <img
            src={linkedinIconSvg}
            alt={format('share on', { platform: 'LinkedIn' })}
          />
        </a>
      </li>
      <li>
        <a
          href={`mailto:?body=${encodeURIComponent(emailBody)}%0D%0A${url}`}
          target="_blank"
          rel="noopener noreferrer"
          title={format('email')}
          onClick={() => sendAnalyticsUIEvent('emailButton')}
        >
          <img src={emailIconSvg} alt={format('email')} />
        </a>
      </li>
    </ul>
  );
};
